import { apiCall } from '../helper.js';

export function updateSection(id, body) {
  return apiCall(`/admin/sections/${id}`, 'PATCH', JSON.stringify(body));
}
